// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-icon-large {
  background-color: transparent;
  border: none;
  height: 28px;
  margin-top: -10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/MoveButton.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AACJ","sourcesContent":[".button-icon-large {\n    background-color: transparent;\n    border: none;\n    height: 28px;\n    margin-top: -10px;\n};\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
